export const productionKmtMock = {
  title: 'Production (KMT)',
  type: 'PRODUCTION_KTM',
  navigation: {
    "nav": {
      "qtd": [
        {
          "graph": {
            "data": [
              {
                "delta": -75,
                "title": "Potash",
                "value": 339,
                "navItem": null,
                "division": 'POTASH',
                "businessUnit": 'Sdom',
                "businessUnitSubtitle": 'Magnesium',
                "subBusinessUnit": 'Granular',
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -18,
                "valueSubtitle": null,
                "compareSubtitle": null,

              },
              {
                "delta": 3,
                "title": "Commodity Fertilizers",
                "value": 79,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 4,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 13,
                "title": "MGA",
                "value": 51,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 34,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -35,
                "title": "Polysulphate",
                "value": 49,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -42,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 1,
                "title": "MKP",
                "value": 6,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 20,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -38,
                "title": "Fertilizers",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -11,
                "title": "BROMINE",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 0,
                "title": "TBBA",
                "value": 4,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 0,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -2,
                "title": "WPA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -18,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -2,
                "title": "Magnesium",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "delta": -10,
                "title": "Potash",
                "value": 339,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -3,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -9,
                "title": "Commodity Fertilizers",
                "value": 79,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -10,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -225,
                "title": "MGA",
                "value": 51,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -81,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -18,
                "title": "Polysulphate",
                "value": 49,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -28,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 0,
                "title": "MKP",
                "value": 6,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 6,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -59,
                "title": "Fertilizers",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -11,
                "title": "BROMINE",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 2,
                "title": "TBBA",
                "value": 4,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 134,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 0,
                "title": "WPA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -2,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -1,
                "title": "Magnesium",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LQ",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "delta": -109,
                "title": "Potash",
                "value": 339,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -24,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -6,
                "title": "Commodity Fertilizers",
                "value": 79,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -7,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 1,
                "title": "MGA",
                "value": 51,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 3,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -35,
                "title": "Polysulphate",
                "value": 49,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -42,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 2,
                "title": "MKP",
                "value": 6,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 38,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -42,
                "title": "Fertilizers",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -16,
                "title": "BROMINE",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 0,
                "title": "TBBA",
                "value": 4,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 0,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -2,
                "title": "WPA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -13,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -2,
                "title": "Magnesium",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": "BGT"
        }
      ],
      "ytd": [
        {
          "graph": {
            "data": [
              {
                "delta": -260,
                "title": "Potash",
                "value": 3620,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -7,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -16,
                "title": "Commodity Fertilizers",
                "value": 848,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -2,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -7,
                "title": "MGA",
                "value": 425,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -2,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 37,
                "title": "Polysulphate",
                "value": 821,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 5,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -14,
                "title": "MKP",
                "value": 52,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -21,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 23,
                "title": "Fertilizers",
                "value": 446,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 5,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -55,
                "title": "BROMINE",
                "value": 96,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -37,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -26,
                "title": "TBBA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -68,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -18,
                "title": "WPA",
                "value": 128,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -12,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -6,
                "title": "Magnesium",
                "value": 12,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -33,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "delta": null,
                "title": "Potash",
                "value": 3620,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "Commodity Fertilizers",
                "value": 848,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "MGA",
                "value": 425,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "Polysulphate",
                "value": 821,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "MKP",
                "value": 52,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "Fertilizers",
                "value": 446,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "BROMINE",
                "value": 96,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "TBBA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "WPA",
                "value": 128,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": null,
                "title": "Magnesium",
                "value": 12,
                "navItem": null,
                "division": null,
                "legendValue": null,
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": null,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "delta": -338,
                "title": "Potash",
                "value": 3620,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -9,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 51,
                "title": "Commodity Fertilizers",
                "value": 848,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 6,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -29,
                "title": "MGA",
                "value": 425,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -6,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -22,
                "title": "Polysulphate",
                "value": 821,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -3,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -13,
                "title": "MKP",
                "value": 52,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -21,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -613,
                "title": "Fertilizers",
                "value": 446,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -58,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -53,
                "title": "BROMINE",
                "value": 96,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -36,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -26,
                "title": "TBBA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -67,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -13,
                "title": "WPA",
                "value": 128,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -9,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -5,
                "title": "Magnesium",
                "value": 12,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -28,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": "BGT"
        }
      ],
      "month": [
        {
          "graph": {
            "data": [
              {
                "delta": -75,
                "title": "Potash",
                "value": 339,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -18,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 3,
                "title": "Commodity Fertilizers",
                "value": 79,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 4,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 13,
                "title": "MGA",
                "value": 51,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 34,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -35,
                "title": "Polysulphate",
                "value": 49,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -42,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 1,
                "title": "MKP",
                "value": 6,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 20,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -38,
                "title": "Fertilizers",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -11,
                "title": "BROMINE",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 0,
                "title": "TBBA",
                "value": 4,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 0,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -2,
                "title": "WPA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -18,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -2,
                "title": "Magnesium",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LY",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": "LY"
        },
        {
          "graph": {
            "data": [
              {
                "delta": -46,
                "title": "Potash",
                "value": 339,
                "navItem": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -12,
                "valueSubtitle": null,
                "compareSubtitle": null,
                "division": 'POTASH',
                "businessUnit": 'Sdom',
                "businessUnitSubtitle": 'Magnesium',
                "subBusinessUnit": 'Granular',
              },
              {
                "delta": -9,
                "title": "Commodity Fertilizers",
                "value": 79,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -10,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 4,
                "title": "MGA",
                "value": 51,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 10,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -41,
                "title": "Polysulphate",
                "value": 49,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -46,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 1,
                "title": "MKP",
                "value": 6,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 14,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -52,
                "title": "Fertilizers",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -12,
                "title": "BROMINE",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 0,
                "title": "TBBA",
                "value": 4,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 15,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 0,
                "title": "WPA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 1,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -1,
                "title": "Magnesium",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "LM",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": ""
        },
        {
          "graph": {
            "data": [
              {
                "delta": -109,
                "title": "Potash",
                "value": 339,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -24,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -6,
                "title": "Commodity Fertilizers",
                "value": 79,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -7,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 1,
                "title": "MGA",
                "value": 51,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 3,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -35,
                "title": "Polysulphate",
                "value": 49,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -42,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 2,
                "title": "MKP",
                "value": 6,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 38,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -42,
                "title": "Fertilizers",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -16,
                "title": "BROMINE",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": 0,
                "title": "TBBA",
                "value": 4,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": 0,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -2,
                "title": "WPA",
                "value": 13,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -13,
                "valueSubtitle": null,
                "compareSubtitle": null
              },
              {
                "delta": -2,
                "title": "Magnesium",
                "value": 0,
                "navItem": null,
                "division": null,
                "legendValue": "BGT",
                "reverseView": null,
                "compareValue": null,
                "deltaPercent": -100,
                "valueSubtitle": null,
                "compareSubtitle": null
              }
            ],
            "isMainGraph": true
          },
          "title": "BGT"
        }
      ]
    },
    "type": "GraphNavigation"
  },
};
